<script lang="ts">
  import { xhr, toast } from "$app/utils"

  type UserTypeExt = UserType & {
    plan_count: number
  }

  interface Props {
    user: UserTypeExt
    status: string
    onupdate: (user: UserTypeExt) => void
    oncreate: (user: UserTypeExt) => void
  }

  let { user, status = "", onupdate, oncreate }: Props = $props()

  let form = $state({})
  let saving = $state(false)

  function saveUser(): void {
    if (status === "edit") {
      updateUser()
    } else {
      createUser()
    }
  }

  let errors: any = $state({})

  async function updateUser(): Promise<void> {
    try {
      saving = true
      const resp = await xhr.patch(`/admin/users/${user.id}.json`, {
        user: form
      })
      toast("User updated successfully", "success")
      onupdate(resp.data)
    } catch (e) {
      console.log(e)
      toast("There was an error saving plan", "error")
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  async function createUser(): Promise<void> {
    try {
      errors = {}
      saving = true
      const resp = await xhr.patch("/admin/users", {
        plan: form
      })
      toast("User updated successfully", "success")
      oncreate(resp.data)
    } catch (e) {
      console.log(e)
      toast("There was an error saving user", "error")
    } finally {
      saving = false
    }
  }

  function setForm(): void {
    form = {
      name: user.name,
      email: user.email,
      display_name: user.display_name,
      title: user.title,
      birthdate: user.birthdate,
      mobile_number: user.mobile_number,
      has_accepted_community_terms: user.has_accepted_community_terms,
      send_push_notifications: user.send_push_notifications,
      send_notification_summary: user.send_notification_summary
    }
  }

  if (status) {
    setForm()
  }
</script>

<form>
  <h2 class="text-base font-semibold leading-6 text-gray-900">
    {status === "edit" ? "Edit" : "New"} User
  </h2>

  <div class="input-cont">
    <label for="name">Full Name</label>
    <input id="name" type="text" class="input" bind:value={form.name} />
    <div class="text-red-500">
      {errors.name || ""}
    </div>
  </div>

  <div class="input-cont">
    <label for="email">Email</label>
    <input id="email" type="text" class="input" bind:value={form.email} />
    <div class="text-red-500">
      {errors.email || ""}
    </div>
  </div>

  <div class="grid grid-cols-2 gap-2">
    <div class="input-cont">
      <label for="title">Title</label>
      <input id="title" type="text" class="input" bind:value={form.title} />
    </div>
    <div class="pl-4 flex items-end">
      <label for="has_accepted_community_terms" class="text-lg">
        <input
          class="input-admin"
          type="checkbox"
          id="has_accepted_community_terms"
          bind:checked={form.has_accepted_community_terms}
        />
        Has Accepted Community Terms
      </label>
    </div>
  </div>

  <div class="input-cont">
    <label for="birthdate">Birthdate</label>
    <input
      id="birthdate"
      type="text"
      class="input"
      bind:value={form.birthdate}
    />
  </div>

  <div class="input-cont">
    <label for="mobile_number">Mobile Number</label>
    <input
      id="mobile_number"
      type="text"
      class="input"
      bind:value={form.mobile_number}
    />
  </div>

  <div class="p-4 text-center">
    <button class="btn big primary" disabled={saving} onclick={saveUser}>
      {status === "edit" ? "Update" : "Create"}
    </button>
  </div>
</form>
